import { Injectable } from '@angular/core';
import { SearchFilters, TableSettings } from '../model/filters-data';

@Injectable({
  providedIn: 'root'
})
export class CustomFiltersService {

  baseFilters: SearchFilters = {
    orderColumn: '',
    order: '',
    page: 0,
    pageSize: 25,
    currentPage: 0,
    inserimento: '',
    stato: '',
    sezione: '',
    tipoLista: '',
    residenzaProvincia: '',
    residenzaComune: '',
    domicilioProvincia: '',
    domicilioComune: '',
    annoNascita: null,
    annoNascitaAl: null,
    titoli: '',
    dataIscrizione: null,
    dataIscrizioneAl: null,
    situazione: '',
    annoMorositaDal: null,
    annoMorositaAl: null,
    numeroAnniMorositaDa: null,
    numeroAnniMorositaAl: null,
    numeroDelibera: undefined,
    tipoDelibera: '',
    chiusa: false,
    finalizzata: false,
    cambioSezione: false,
    statoIscrizione: '',
    verificati: null
  }

  //gestisce i filtri del componente
  handleFilterByComponent(componenete: string): SearchFilters{

    const data = this.getDataFromSessionStorage();

    if(data && data[componenete]){
      return data[componenete];
    }

    if(data && !data[componenete]){
      const newFilter = this.createFilter(componenete);
      data[componenete] = newFilter;
      sessionStorage.setItem('data', JSON.stringify(data));
      return newFilter;
    }

    if(!data){
      let newData: {[key: string]: {}} = {};
      const newFilter = this.createFilter(componenete);
      newData[componenete] = newFilter;
      sessionStorage.setItem('data', JSON.stringify(newData));
      return newFilter;
    }

    throw new Error('Errore nella gestione dei filtri.');

  }

  //salvataggio in session storage dai componenti
  sessionStorageUpdate(values: any, componente: string, tabSett: TableSettings): SearchFilters{

    const sessionData = JSON.parse(sessionStorage.getItem('data')!);

    sessionData[componente].inserimento = values.inserimento;
    sessionData[componente].stato = values.stato?.codiceCnop ? values.stato?.codiceCnop : '';

    if(['provvisori_a', 'psi_a', 'provvisori_a_finalizza', 'psi_a_finalizza', 'cambio_sezione', 'cambio_sezione_finalizza'].includes(componente))
      sessionData[componente].sezione = 'A';
    else if(['provvisori_b', 'provvisori_b_finalizza'].includes(componente))
      sessionData[componente].sezione = 'B';
    else
      sessionData[componente].sezione = values.sezione?.valore ? values.sezione?.valore : '';

    sessionData[componente].orderColumn = tabSett.orderColumnName;
    sessionData[componente].order = tabSett.order;
    sessionData[componente].page = tabSett.page;
    sessionData[componente].pageSize = tabSett.pageSize;
    sessionData[componente].currentPage = tabSett.currentPage;

    const rp = values.residenzaProvincia;
    sessionData[componente].residenzaProvincia = rp ? rp?.codice : '';

    const rc = values.residenzaComune;
    sessionData[componente].residenzaComune = rc?.codice_catastale ? rc?.codice_catastale : '';

    const dp = values.domicilioProvincia;
    sessionData[componente].domicilioProvincia = dp ? dp.codice : '';

    const dc = values.domicilioComune;
    sessionData[componente].domicilioComune = dc?.codice_catastale ? dc?.codice_catastale : '';

    sessionData[componente].annoNascita = values.annoNascita ? values.annoNascita : null;
    sessionData[componente].annoNascitaAl = values.annoNascitaAl ? values.annoNascitaAl : null;

    sessionData[componente].titoli = values.titoli ? values.titoli.id.toString() : '';
    sessionData[componente].noPec = values.noPec;
    sessionData[componente].permessoSoggiorno = values.permessoSoggiorno;
    sessionData[componente].ctu = values.ctu ? values.ctu.id.toString() : '';
    sessionData[componente].perito = values.perito ? values.perito.id.toString() : '';

    sessionData[componente].dataIscrizione = values.dataIscrizione ? this.buildDate(values.dataIscrizione) : null;
    sessionData[componente].dataIscrizioneAl = values.dataIscrizioneAl ? this.buildDate(values.dataIscrizioneAl) : null;

    sessionData[componente].situazione = values.situazione ? values.situazione.valore : '';
    sessionData[componente].annoMorositaDal = values.annoMorositaDal ? values.annoMorositaDal : null;
    sessionData[componente].annoMorositaAl = values.annoMorositaAl ? values.annoMorositaAl : null;
    sessionData[componente].numeroAnniMorositaDa = values.numeroAnniMorositaDa ? values.numeroAnniMorositaDa : null;
    sessionData[componente].numeroAnniMorositaAl = values.numeroAnniMorositaAl ? values.numeroAnniMorositaAl : null;

    sessionData[componente].numeroDelibera = values.numeroDelibera;
    sessionData[componente].tipoDelibera = values.tipoDelibera?.codice ? values.tipoDelibera?.codice : '';
    sessionData[componente].chiusa = ['delibereChiuse'].includes(componente);
    sessionData[componente].finalizzata = ['delibereFinalizzate'].includes(componente);
    sessionData[componente].cambioSezione = ['cambio_sezione', 'cambio_sezione_finalizza'].includes(componente);

    sessionData[componente].statoIscrizione = '';
    sessionData[componente].verificati = values.verificati ?? null;

    sessionStorage.setItem(`data`, JSON.stringify(sessionData));

    return sessionData[componente];

  }

  //verifica genericamente se data esiste e lo rende stringa
  private getDataFromSessionStorage(){
    const data = sessionStorage.getItem('data');
    return data ? JSON.parse(data) : null;
  }

  // creazione di un nuovo filtro in base al componente
  private createFilter(componente: string): SearchFilters{

    const newFilter = this.baseFilters;
    newFilter.tipoLista = componente;

    switch(componente){

      case 'iscritti':
      case 'provvisori':
      case 'cancellati':
      case 'stpList':
      case 'stpFilters':
      case 'contabile':
      case 'contabile-cancellati':
      case 'contabile-stp': {
        newFilter.orderColumn = 'codiceFiscale';
        newFilter.order = 'ASC';
        break;
      }

      case 'provvisori_a':
      case 'psi_a':
      case 'provvisori_a_finalizza':
      case 'psi_a_finalizza': {
        newFilter.orderColumn = 'codiceFiscale';
        newFilter.order = 'ASC';
        newFilter.sezione = 'A';
        newFilter.cambioSezione = false;
        break;
      }

      case 'cambio_sezione':
      case 'cambio_sezione_finalizza': {
        newFilter.orderColumn = 'codiceFiscale';
        newFilter.order = 'ASC';
        newFilter.sezione = 'A';
        newFilter.cambioSezione = true;
        break;
      }

      case 'provvisori_b':
      case 'provvisori_b_finalizza': {
        newFilter.orderColumn = 'codiceFiscale';
        newFilter.order = 'ASC';
        newFilter.sezione = 'B';
        newFilter.cambioSezione = false;
        break;
      }

      case 'trasferimento':
      case 'trasferimento_finalizza':
      case 'delibera_chiusa': {
        newFilter.orderColumn = 'codiceFiscale';
        newFilter.order = 'ASC';
        newFilter.sezione = '';
        newFilter.cambioSezione = false;
        break;
      }

      case 'delibere':{
        newFilter.orderColumn = 'dataDelibera';
        newFilter.order = 'DESC';
        newFilter.finalizzata = false;
        newFilter.chiusa = false;
        break;
      }

      case 'delibereFinalizzate':{
        newFilter.orderColumn = 'dataDelibera';
        newFilter.order = 'DESC';
        newFilter.finalizzata = true;
        newFilter.chiusa = false;
        break;
      }

      case 'delibereChiuse':{
        newFilter.orderColumn = 'dataDelibera';
        newFilter.order = 'DESC';
        newFilter.finalizzata = false;
        newFilter.chiusa = true;
        break;
      }

      case 'gestione_domande_iscrizione':
      case 'storico_domande_iscrizione': {
        newFilter.orderColumn = 'domandaProtocollo';
        newFilter.order = 'ASC';
        break;
      }

      default:{
        break;
      }

    }

    return newFilter;

  }

  private buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());

    const data = `${year}-${month}-${day}`;

    return data;
  }

}
